<template>
<div class="service-takeback">
  <h2>回售機制與流程</h2>
  <div class="service-step">
    <div class="">
      <img src="@/images/serviceTakeback-step1@2x.png" alt="">
    </div>
    <div class="">
      <img src="@/images/serviceTakeback-step2@2x.png" alt="">
    </div>
    <div class="">
      <img src="@/images/serviceTakeback-step3@2x.png" alt="">
    </div>
  </div>
  <p>在金牌王國購買的金牌，都能以現在的黃金價格再回售給金牌王國，回售價格制訂，依實際收到回售商品當時之掛牌價格計算。如欲回售商品不是在金牌王國購買的金牌中，也以一般回售報價掛牌價格計算。現場回售者請至現場填寫表單，線上寄送回售者需事先填寫以下表單:</p>
  <div class="form-container">
    <div id="myRadio">
      <input type="radio" id="personal" name="productType" checked  value="true" v-model="saleType">
      <label for="personal">金牌王國購買之商品</label>
      <div class="check"></div>
    </div>
    <div id="myRadio">
      <input type="radio" id="company" name="productType" value="" v-model="saleType">
      <label for="company">其他黃金商品</label>
      <div class="check"></div>
    </div>
    <div id="kingdom-gold" v-if="saleType">
      <div class="form-title">輸入金牌編號</div>
      <div class="search-gold">
        <input type="text" v-model="searchGoldNum" placeholder="例:AA00600010">
        <button v-on:click="searchGold">送出</button>
      </div>
      <div class="search-list">
        <div class="item-title title-WH">品項名稱</div>
        <div class="price-title title-WH">目前回售價格(當日價格)</div>
        <div class="item-text text-WH">{{searchGoldProduct}}</div>
        <div class="price-text text-WH" v-if="searchGoldProductPrice">TWD {{searchGoldProductPrice}}</div>
      </div>
      <p class="notice-text">收到商品和您提交的表單和商品後會立刻和您報價，報價價格為<a href="https://tw9999.tw/">台灣銀樓報價系統</a>之即時黃金飾金買進價格</p>
    </div>
    <div id="other-gold" v-else>
      <div>
        <div class="form-title">輸入商品名稱</div>
        <input type="text" required v-model="saleBack.productName">
      </div>
      <div>
        <div class="form-title">重量(錢)</div>
        <input type="text" required v-model="saleBack.weight">
      </div>
      <p class="notice-text">收到商品和您提交的表單和商品後會立刻和您報價，報價價格為<a href="https://tw9999.tw/">台灣銀樓報價系統</a>之即時黃金飾金買進價格</p>
    </div>
    <form>
      <div id="personal-info">
        <h4>個人資料</h4>
        <div class="flex-container name-container">
          <div class="flex-item">
            <div class="form-title">名字</div>
            <input type="text" required v-model="saleBack.firstName">
          </div>
          <div class="flex-item">
            <div class="form-title">姓氏</div>
            <input type="text" required v-model="saleBack.lastName">
          </div>
        </div>
        <div>
          <div class="form-title">手機</div>
          <input type="text" required pattern="^[0-9]{0,255}" oninvalid="setCustomValidity('請輸入手機號碼(純數字)')" oninput="setCustomValidity('')" v-model="saleBack.phone">
        </div>
        <div>
          <div class="form-title">電子信箱</div>
          <input class="emailExamine" type="email" required v-model="saleBack.email" placeholder="例:abc123@gmail.com">
        </div>
        <div>
          <div class="form-title">住址</div>
          <div class="address-container">
            <div class="flex-container">
              <input class="flex-item" type="text" required v-model="saleBack.country" placeholder="台灣">
              <div class="dropdown-title flex-item">
                <a href="#" v-on:click.prevent="showDropDown_city=!showDropDown_city">
                  <div :class="{'title-color':chooseCity===''}">{{chooseCity?chooseCity:"縣市"}}</div>
                  <i
                    :class="{ 'fa-caret-up': showDropDown_city, 'fa-caret-down': !showDropDown_city }"
                    class="fa"
                    aria-hidden="true"
                  ></i>
                </a>
                <transition name="slide-fade">
                  <div class="choice" v-if="showDropDown_city">
                    <ul>
                      <li v-for="(city,index) in displayCityList" :key="index" @click="showDropDown_city=!showDropDown_city">
                        <span class="item" @click="chooseCity=city">{{city}}</span>
                      </li>
                    </ul>
                  </div>
                </transition>
              </div>
              <div class="dropdown-title flex-item">
                <a href="#" v-on:click.prevent="showDropDown_zipcode=!showDropDown_zipcode">
                  <div
                    :class="{'title-color':displayZipCodeInfo===''}"
                  >{{displayZipCodeInfo?displayZipCodeInfo:"郵遞區號"}}</div>
                  <i
                    :class="{ 'fa-caret-up': showDropDown_zipcode, 'fa-caret-down': !showDropDown_zipcode }"
                    class="fa"
                    aria-hidden="true"
                  ></i>
                </a>
                <transition name="slide-fade">
                  <div class="choice" v-if="showDropDown_zipcode">
                    <ul>
                      <li v-for="(zipcode,index) in displayZipCodeList" :key="index" @click="showDropDown_zipcode=!showDropDown_zipcode">
                        <span class="item" @click="saleBack.postalCode=zipcode.zopcode">{{zipcode.region+zipcode.zopcode}}</span>
                      </li>
                    </ul>
                  </div>
                </transition>
              </div>
            </div>
            <input type="text" placeholder="地址" required v-model="saleBack.address">

          </div>


        </div>
        <div>
          <div class="form-title">匯款銀行</div>
          <input type="text" required v-model="saleBack.bankName">
        </div>
        <div>
          <div class="form-title">銀行分行</div>
          <input type="text" required v-model="saleBack.bankBranch">
        </div>
        <div>
          <div class="form-title">銀行戶名</div>
          <input type="text" required v-model="saleBack.bankAccountName">
        </div>
        <div>
          <div class="form-title">銀行帳號</div>
          <input type="text" required v-model="saleBack.bankAccountNumber" pattern="[0-9]{0,255}">
        </div>
      </div>
    </form>
    <button v-on:click="sendSaleBackData">提交表單</button>
    <div class="mobile_backNav" v-if="isMobileButtonShow">
      <i class="fa fa-angle-left"></i>
      <router-link to="/gold/service_mobile">返回說明與服務</router-link>
    </div>
  </div>
</div>
</template>

<script>
import axios from "axios";
import taiwanZipcodeData from "@/constData/taiwanZipCode.js";
export default {
  name: "serviceTakeback",
  data() {
    return {
      isMobileButtonShow: false,
      saleType: "true",
      searchGoldNum: "",
      searchGoldProduct: "",
      searchGoldProductPrice: "",
      saleBack: {
        productName: "",
        weight: "",
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        country: "台灣",
        postalCode: "",
        address: "",
        bankName: "",
        bankBranch: "",
        bankAccountName: "",
        bankAccountNumber: ""
      },
      showDropDown_city: false,
      showDropDown_zipcode: false,
      taiwanZipcodeData: taiwanZipcodeData.taiwanZipcodeData,
      chooseCity: ""
    };
  },
  created() {
    let device = this.$store.getters.getDeviceSize;
    if (device < 585) {
      this.isMobileButtonShow = true;
    }
  },
  watch: {
    searchGoldNum() {
      this.searchGoldProduct = "";
      this.searchGoldProductPrice = "";
    },
    saleType() {
      if (this.saleType == "") {
        this.searchGoldNum = "";
        this.searchGoldProduct = "";
        this.searchGoldProductPrice = "";
      }
      this.saleBack.productName = "";
      this.saleBack.weight = "";
    }
  },
  methods: {
    searchGold() {
      //先驗證
      if (this.searchGoldNum.length !== 10) {
        alert("您的格式輸入錯誤，請再次確認金牌編號");
        return;
      } else if (!isNaN(parseInt(this.searchGoldNum.substr(0, 2)))) {
        alert("您的格式輸入錯誤，請再次確認金牌編號");
        return;
      } else if (
        isNaN(parseInt(this.searchGoldNum.substr(2, this.searchGoldNum.length)))
      ) {
        alert("您的格式輸入錯誤，請再次確認金牌編號");
        return;
      }
      let way = this.searchWay(this.searchGoldNum.substr(0, 1));
      if (way == "查無此金牌") {
        alert("您的格式輸入錯誤，請再次確認金牌編號");
        return;
      }
      let cmLength = parseInt(this.searchGoldNum.substr(2, 3)).toString();
      let weight =
        parseInt(this.searchGoldNum.substr(5, 3)) +
        "." +
        parseInt(this.searchGoldNum.substr(8, 2));
      this.searchGoldProduct = `${cmLength}公分${weight}錢${way}`;
      this.getSearchGoldProductPrice(
        this.searchGoldNum.substr(0, 1),
        cmLength,
        weight
      );
      this.saleBack.productName = `${cmLength}公分${weight}錢${way}`;
      this.saleBack.weight = weight;
    },
    searchWay(code) {
      return this.$store.getters.getTransformWay(code);
    },
    getSearchGoldProductPrice(way, cm, weight) {
      let orderData = [
        { type: "resale", way: way, unit: "cm", length: cm, weight: weight }
      ];
      axios({
        url: this.$store.getters.getGlobalUrl + "gold/calculate",
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        data: orderData
      })
        .then(response => {
          this.searchGoldProductPrice = response.data.data[0].price;
        })
        .catch(e => {
          alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
        });
    },
    sendSaleBackData() {
      let checkResult = this.examineData();
      if (checkResult == "ok") {
        let currentdate = new Date();
        let filltime =
          currentdate.getFullYear() +
          "/" +
          (currentdate.getMonth() + 1) +
          "/" +
          currentdate.getDate() +
          "  " +
          currentdate.getHours() +
          ":" +
          currentdate.getMinutes() +
          ":" +
          currentdate.getSeconds();
        this.saleBack.time = filltime;
        this.saleBack.price = this.searchGoldProductPrice || "非金牌商品";
        this.saleBack.address = this.chooseCity + this.saleBack.address;
        axios({
          url:
            "https://script.google.com/macros/s/AKfycbyvSXeu_0C1mk3cBMb3oRU6z8KnLLDDvIhthxdFFq6jCLeAszLD/exec",
          method: "get",
          params: this.saleBack
        })
          .then(() => {
            alert("提交成功，金牌王國會儘快與您聯絡");
            this.resetData();
          })
          .catch(e => {
            alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
          });
      }
    },
    examineData() {
      let allInput = document.querySelectorAll("input");
      let email = document.querySelector(".emailExamine");
      allInput.forEach(item => {
        item.style.border = "1px solid #a8894c";
      });
      email.style.border = "1px solid #a8894c";
      let errorData = document.querySelectorAll("input:invalid");
      let emailExamine = /^.*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
      if (errorData.length !== 0) {
        alert("尚有聯絡資料未填寫或格式錯誤");
        errorData.forEach(item => {
          item.style.border = "2px solid red";
        });
        return "error";
      } else if (!emailExamine.test(this.saleBack.email)) {
        email.style.border = "2px solid red";
        return "error";
      } else if (
        this.saleBack.productName == "" ||
        this.saleBack.weight == ""
      ) {
        alert("回售商品尚未填寫或格式錯誤");
        return "error";
      } else {
        return "ok";
      }
    },
    resetData() {
      this.searchGoldNum = "";
      this.searchGoldProduct = "";
      this.searchGoldProductPrice = "";
      this.saleBack = {
        productName: "",
        weight: "",
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        country: "",
        postalCode: "",
        address: "",
        bankName: "",
        bankBranch: "",
        bankAccountName: "",
        bankAccountNumber: ""
      };
    }
  },
  computed: {
    displayCityList() {
      let cityList = [];
      for (let city in this.taiwanZipcodeData) {
        cityList.push(city);
      }
      return cityList;
    },
    displayZipCodeList() {
      if (this.chooseCity !== "") {
        let zipcodeList = [];
        this.taiwanZipcodeData[`${this.chooseCity}`].forEach(item => {
          let keyValue = Object.entries(item)[0];
          zipcodeList.push({
            region: keyValue[0],
            zopcode: keyValue[1]
          });
        });
        return zipcodeList;
      } else {
        return [];
      }
    },
    displayZipCodeInfo() {
      let displayZipCode = "";
      if (this.saleBack.postalCode === "" || this.chooseCity === "") {
        return "";
      } else {
        for (let cityValue in this.taiwanZipcodeData) {
          this.taiwanZipcodeData[`${this.chooseCity}`].forEach(region => {
            for (let regionName in region) {
              if (region[`${regionName}`] === this.saleBack.postalCode) {
                displayZipCode = regionName + region[`${regionName}`];
              }
            }
          });
        }
        return displayZipCode;
      }
    }
  }
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
  letter-spacing: 1px;
}
p {
  font-size: 17px;
  color: $secondaryDeepColor1;
  line-height: 30px;
}
.service-takeback {
  width: 66.73%;
  text-align: left;
  h2 {
    font-size: 35px;
    font-weight: 600;
    letter-spacing: 2px;
    color: $primaryDeepColor;
    margin-top: 0;
  }
  @include betweenPhoneTable {
    width: 100%;
  }
}
.service-step {
  display: flex;
  div {
    width: 33.333%;
  }
  img {
    width: 95%;
  }
  @include betweenTableTablePro {
    flex-direction: column;
    div {
      text-align: center;
      width: 60%;
    }
  }
  @include betweenPhoneTable {
    div {
      width: 100%;
    }
  }
}
.service-goldprice {
  width: 66.73%;
  text-align: left;
  h2 {
    font-size: 35px;
    font-weight: 600;
    letter-spacing: 2px;
    color: $primaryDeepColor;
    margin-top: 0;
  }
  p {
    font-size: 17px;
    color: $secondaryDeepColor1;
    line-height: 30px;
  }
}
.form-container {
  text-align: left;
  font-size: 17px;
  color: $secondaryDeepColor1;
}
h4 {
  margin-top: 30px;
  margin-bottom: 16px;
}
.name-container {
  .flex-item {
    width: 48%;
    @include table {
      width: 100%;
    }
  }
}
.flex-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.address-container {
  .flex-item {
    width: 32%;
    @include table {
      width: 100%;
    }
  }
  .flex-container {
    margin-bottom: 15px;
    @include table {
      margin-bottom: 0;
    }
  }
  .address-notice {
    margin-bottom: 30px;
  }
  .flex-container > * {
    @include table {
      margin-bottom: 15px;
    }
  }
}
.form-title {
  margin-top: 15px;
  margin-bottom: 8px;
  font-weight: 600;
}
.search-gold {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  input {
    width: 260px;
    margin-right: 10px;
  }
  button {
    border-radius: 0;
    max-width: 105px;
    height: 55px;
    margin-top: 0;
    background-color: $primaryLightColor;
    color: white;
    &:hover {
      background-color: $primaryDeepColor;
    }
  }
  @media all and (max-width: 360px) {
    flex-wrap: wrap;
    input {
      margin-right: 0;
      width: 100%;
    }
    button {
      max-width: 100%;
      margin-top: 5px;
    }
  }
}
.search-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  border: 1px solid $primaryDeepColor;
  @include table {
    grid-template-columns: 1fr;
    grid-template-rows: 45px 65px 45px 65px;
  }
}
.title-WH {
  padding: 10px 15px;
  border-bottom: 1px solid $primaryDeepColor;
  @include table {
    border-bottom: 0;
    margin-bottom: -12px;
  }
}
.text-WH {
  padding: 20px 15px;
  @include table {
    margin-top: -12px;
  }
}
.price-title,
.price-text {
  text-align: right;
  @include table {
    text-align: left;
  }
}
.price-title {
  @include table {
    grid-row: 3 / 4;
  }
}
.item-text {
  font-weight: 600;
  @include table {
    grid-row: 2 / 3;
  }
}
.price-text {
  font-size: 24px;
  font-weight: 600;
  @include table {
    grid-row: 4 / end;
  }
}
.notice-text {
  color: $secondaryColor2;
  margin-top: 7px;
  a {
    color: #4a90e2;
    text-decoration: underline;
  }
}
input {
  width: 100%;
  padding: 16px;
  font-size: 17px;
  border: 1px solid $primaryDeepColor;
  background-color: rgba(0, 0, 0, 0);
}
button {
  @extend %button;
  margin-top: 30px;
  @include betweenPhoneTable {
    width: 100%;
  }
}
.mobile_backNav {
  margin-top: 24px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    color: $primaryDeepColor;
    margin-right: 10px;
  }
  a {
    color: $primaryDeepColor;
  }
}
/*******************************
radio style
*******************************/
#myRadio {
  position: relative;
}
#myRadio label {
  font-weight: normal;
  display: block;
  position: relative;
  padding: 8px 41px;
  z-index: 9;
  cursor: pointer;
}
#myRadio:hover label {
  color: #bf9f5f;
}
#myRadio .check {
  position: absolute;
  border: 2px solid #a8894c;
  border-radius: 50%;
  height: 25px;
  width: 25px;
  top: 8px;
  left: 0;
  z-index: 5;
}
#myRadio:hover .check {
  border: 2px solid #bf9f5f;
}
#myRadio .check::before {
  display: block;
  position: absolute;
  content: "";
  border-radius: 50%;
  height: 15px;
  width: 15px;
  top: 3px;
  left: 3px;
  margin: auto;
}
#myRadio input[type="radio"] {
  position: absolute;
  visibility: hidden;
}
input[type="radio"]:checked ~ .check::before {
  background: #a8894c;
}
input[type="radio"]:checked ~ label {
  color: #a8894c;
}

//dropdown
.dropdown-title {
  position: relative;
  a,
  .item {
    color: $secondaryDeepColor1;
    text-decoration: none;
    display: flex;
    align-items: center;
    border: 1px $primaryDeepColor solid;
    padding: 15px 15px 15px 10px;
    width: 100%;
  }
  a {
    background-color: rgba(0, 0, 0, 0);
  }
  .item {
    background-color: #fefff9;
  }
  .item:hover {
    color: $secondaryColor3;
    background-color: $primaryLightColor;
  }
  .title-color {
    color: $secondaryLightColor1;
  }
}
ul {
  display: block;
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.choice {
  position: absolute;
  width: 100%;
  z-index: 99;
  max-height: 365px;
  overflow-y: scroll;
}
.fa {
  margin-left: auto;
  color: $primaryLightColor;
}
</style>
